import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";
import {
  convertLegalEntityEnumToDisplay,
  CORPORATION,
  LIMITED_LIABILITY_COMPANY,
  OTHER,
  PARTNERSHIP,
} from "../../../constants/legalEntityTypes";
import { PLACEHOLDER_NONE } from "../../../constants/selectionValues";
import { CenteredRow, Col, Grid } from "../../shared/Layout";
import { RadioListNormalLegend } from "../../shared/RadioList";

const CompanyTypeRadioList = styled(RadioListNormalLegend).attrs({
  id: "existingBusinessInformation_businessCompanyType_Radios",
  legendText: "What is your company type?",
  errorReplacesHelper: false,
  radios: [
    {
      id: "existingBusinessInformation_businessCompanyType_Radio_LimitedLiabilityCompany",
      label: "Multi Member LLC",
      value: LIMITED_LIABILITY_COMPANY,
    },
    {
      id: "existingBusinessInformation_businessCompanyType_Radio_Partnership",
      label: convertLegalEntityEnumToDisplay(PARTNERSHIP),
      value: PARTNERSHIP,
    },
    {
      id: "existingBusinessInformation_businessCompanyType_Radio_Corporation",
      label: convertLegalEntityEnumToDisplay(CORPORATION),
      value: CORPORATION,
    },
    {
      id: "existingBusinessInformation_businessCompanyType_Radio_SomethingElse",
      label: convertLegalEntityEnumToDisplay(OTHER),
      value: OTHER,
    },
  ],
})`
  margin-bottom: 0px;

  /* Make legend into flex column so error stacks under helper text */
  & > legend {
    display: flex;
    flex-direction: column;
  }

  /* Better than passing error classes since this maintains the Gravity form classes on the error element */
  & > legend > [role="alert"] {
    margin-top: var(--grv-size-spacing-medium-2);
  }
`;

const ExistingNonProfitCompanyTypeSection = () => {
  const { control, resetField } = useFormContext();

  return (
    <Grid>
      <CenteredRow>
        <Col lg={8} md={8} sm={4}>
          <Controller
            control={control}
            name="companyTypeSelected"
            render={({ field: { onChange, ...rest }, fieldState: { error } }) => (
              <CompanyTypeRadioList
                error={error?.message}
                onChange={event => {
                  // reset tax classification and partnership structure to clear old values
                  // this should prevent invalid combinations of values from switching between company types
                  resetField("partnershipStructure");
                  // defaultValue set manually for taxClassification to avoid issues of navigating back causing
                  // the dropdown to get set to whatever field was selected before, even if the company type has changed
                  resetField("taxClassification", { defaultValue: PLACEHOLDER_NONE });
                  // then finally call onChange normally
                  onChange(event);
                }}
                {...rest}
              />
            )}
          />
        </Col>
      </CenteredRow>
    </Grid>
  );
};

export default ExistingNonProfitCompanyTypeSection;
